import styled from 'styled-components';

import { PADDING_CONTENT_PAGE, COLOR_CONTROLLED_INPUT_NORMAL, BORDER_COLOR_CONTROLLED_INPUT_NORMAL, BORDER_COLOR_CONTROLLED_INPUT_VALID, BORDER_COLOR_CONTROLLED_INPUT_ERROR, BACKGROUND_SIDE_BAR, BACKGROUND_HEADER } from '../../../globals';


export const StyledControlledInput = styled.div`
  margin-top: 2px;
  padding: 0px ${PADDING_CONTENT_PAGE}px 0px ${PADDING_CONTENT_PAGE}px;

  .controlled-input-container { 
    position: relative; 
  }

  .controlled-input-container .fa {
    position: absolute;
    padding-right: 9px;
    pointer-events: none;
    left:  5px;
    top: 7px;
  }

  .controlled-input-container input { 
    padding-left:  35px; 
  }

  .controlled-input-input {
    border-width: 0px 0px 2px 0px;
    border-style: solid;
    border-color: ${BACKGROUND_SIDE_BAR};
    box-shadow: none;
    font-size: 1em;
    border-radius: 0px;
    color: ${BACKGROUND_SIDE_BAR};    
  }

  .controlled-input-input:focus {
    box-shadow: none;
    outline: none;
    border-color: ${BACKGROUND_HEADER};
  }

  .controlled-input-icon {
    font-size: 1.5em;
  }


  .controlled-input-normal {
    border-color: ${BORDER_COLOR_CONTROLLED_INPUT_NORMAL};
  }

  .controlled-input-valid {
    border-color: ${BORDER_COLOR_CONTROLLED_INPUT_VALID};
  }

  .controlled-input-invalid {
    border-color: ${BORDER_COLOR_CONTROLLED_INPUT_ERROR};
  }


  .controlled-input-icon-normal {
    color: ${COLOR_CONTROLLED_INPUT_NORMAL};
  }

  .controlled-input-icon-valid {
    color: ${BORDER_COLOR_CONTROLLED_INPUT_VALID};
  }

  .controlled-input-icon-invalid {
    color: ${BORDER_COLOR_CONTROLLED_INPUT_ERROR};
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
      transition: all 5000s ease-in-out 0s;
      transition-property: background-color, color;
  }

`;



// WEBPACK FOOTER //
// ./src/common/ControlledInput/styles/StyledControlledInput.js